import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import { ARCHIVED } from 'modules/queues/constants/queueEnforcementTypes';
import { updateAppointmentsTotalCount } from 'modules/queues/common/actions/appointmentInfo';
import { getAppointmentsFilters } from '../utils/getAppointmentsFilters';
import {
  FETCH_ARCHIVED_APPOINTMENTS as FETCH_ARCHIVED_APPOINTMENTS_SERVICE,
  FETCH_ARCHIVED_APPOINTMENTS_IDS_AND_CURSOR as FETCH_ARCHIVED_APPOINTMENTS_IDS_AND_CURSOR_SERVICE,
} from '../services/fetchArchivedAppointments';

import createAction from './';


export const FETCH_ARCHIVED_APPOINTMENTS = createAsyncAction(createAction('FETCH_ARCHIVED_APPOINTMENTS'));
export const FETCH_MORE_ARCHIVED_APPOINTMENTS = createAsyncAction(createAction('FETCH_MORE_ARCHIVED_APPOINTMENTS'));


let observableQuery = null;

export const fetchArchivedAppointments = ({ background } = {}) => (dispatch, getState) => {
  if (!background) dispatch({ type: FETCH_ARCHIVED_APPOINTMENTS.pending });

  const state = getState();
  const { textSearch, activeSortField } = state.queues.archive.archiveAppointmentsFilters;

  const apiCallParams = {
    query: FETCH_ARCHIVED_APPOINTMENTS_SERVICE,
    fetchPolicy: 'no-cache',
    variables: {
      page: 1,
      perPage: 20,
      textSearch,
      sort: activeSortField,
      filters: getAppointmentsFilters(state),
    },
  };

  const callFn = (params) => new Promise((resolve, reject) => {
    observableQuery && observableQuery.unsubscribe();

    return observableQuery = apolloClient.watchQuery(params)
      .subscribe({
        next: ({ data: { archivedAppointments } }) => {
          const { totalCount, edges } = archivedAppointments;

          dispatch({
            type: FETCH_ARCHIVED_APPOINTMENTS.success,
            payload: { edges },
          });

          dispatch(updateAppointmentsTotalCount(totalCount, ARCHIVED));

          observableQuery.unsubscribe();
          resolve(archivedAppointments);
        },
        error: (err) => {
          observableQuery && observableQuery.unsubscribe();
          dispatch(errorAction(FETCH_ARCHIVED_APPOINTMENTS.failure, err));
          reject(err);
        },
      });
  });

  return apiCall(callFn, apiCallParams);
};

export const fetchMoreArchivedAppointments = () => (dispatch, getState) => {
  dispatch({ type: FETCH_MORE_ARCHIVED_APPOINTMENTS.pending });

  const state = getState();
  const { textSearch, activeSortField } = state.queues.archive.archiveAppointmentsFilters;
  const appointmentsLength = state.queues.archive.archiveAppointments.byId.length;
  const currentPage = Math.floor(appointmentsLength / 20);


  const apiCallParams = {
    query: FETCH_ARCHIVED_APPOINTMENTS_SERVICE,
    fetchPolicy: 'no-cache',
    variables: {
      page: currentPage + 1,
      perPage: 20,
      textSearch,
      sort: activeSortField,
      filters: getAppointmentsFilters(state),
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { archivedAppointments } }) => {
      const edges = archivedAppointments.edges.slice(appointmentsLength % 20);
      dispatch({
        type: FETCH_MORE_ARCHIVED_APPOINTMENTS.success,
        payload: { edges },
      });
    })
    .catch((err) => dispatch(errorAction(FETCH_MORE_ARCHIVED_APPOINTMENTS.failure, err)));
};


export const fetchArchivedAppointmentsListIdsAndCursor = () => (dispatch, getState) => {
  const state = getState();
  const appointmentsLength = state.queues.schedule.appointments.byId.length;
  const { textSearch, activeSortField } = state.queues.archive.archiveAppointmentsFilters;

  const apiCallParams = {
    query: FETCH_ARCHIVED_APPOINTMENTS_IDS_AND_CURSOR_SERVICE,
    fetchPolicy: 'no-cache',
    variables: {
      page: 1,
      perPage: Math.max(20, appointmentsLength + 1),
      textSearch,
      sort: activeSortField,
      filters: getAppointmentsFilters(state),
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { archivedAppointments: { edges, totalCount: nextTotalCount } } }) => {
      const totalCount = state.queues.common.appointmentInfo.queuesSize[ARCHIVED];

      if (totalCount !== nextTotalCount) {
        dispatch(updateAppointmentsTotalCount(nextTotalCount, ARCHIVED));
      }

      return edges.map(edge => ({ appointmentId: edge.appointment.appointmentId }));
    })
    .catch(() => {
    });
};
